<template>
  <template v-if="!groupInfo?.length">
    <template v-if="!virtual.enabled">
      <qf-table-row :ref="setRefs(row)" v-for="(row, rowIndex) in data" :key="row?.[rowKey]" :row="row" :rowIndex="rowIndex" :columns="columns" :expandIcon="expandIcon" :expandedRowKeys="erp" :errorRowList="errorRowList" :checkedParams="checkedParams" :activeRowKeys="activeRowKeys" :checkBoxClassName="checkBoxClassName" :cornerMark="cornerMark" :isLastRow="rowIndex === data?.length - 1" @rowClick="handleRowClick" @handleChecked="handleChecked" @update:expandedRowKeys="handleExpandRow" @expandChange="expandChange" @onDragstart="onDragstart($event, row)" @mouseover="onDragmouseover($event, row)">
        <template v-for="(_, name) in $slots" #[name]="slotProps" :key="name">
          <slot :name="name" v-bind="slotProps" />
        </template>
      </qf-table-row>
    </template>
    <template v-else>
      <!-- 渲染可视区域及缓冲区的行 -->
      <template v-for="(row, rowIndex) in visibleRows" :key="row.key">
        <div class="qf-table-virtual-row" :ref="(el) => setRowRef(el, row.originalIndex)" :style="getRowStyle(row)">
          <!-- 真实行数据 -->
          <template v-if="!row.isPlaceholder">
            <qf-table-row :row="row.data" :ref="setRefs(row.data)" :rowIndex="row.originalIndex" :columns="columns" :expandIcon="expandIcon" :expandedRowKeys="erp" :errorRowList="errorRowList" :checkedParams="checkedParams" :activeRowKeys="activeRowKeys" :checkBoxClassName="checkBoxClassName" :cornerMark="cornerMark" :isLastRow="rowIndex === data?.length - 1" @rowClick="handleRowClick" @handleChecked="handleChecked" @update:expandedRowKeys="handleExpandRow" @expandChange="expandChange" @onDragstart="onDragstart($event, row.data)" @mouseover="onDragmouseover($event, row.data)">
              <template v-for="(_, name) in $slots" #[name]="slotProps" :key="name">
                <slot :name="name" v-bind="slotProps" />
              </template>
            </qf-table-row>
          </template>
          <!-- 占位行 -->
          <div v-else class="qf-table-row-placeholder"></div>
        </div>
      </template>
    </template>
  </template>
  <template v-else>
    <qf-table-body-group ref="qfTableBodyGroupRef" :columns="columns" :groupData="data" :errorRowList="errorRowList" :checkedParams="checkedParams" :activeRowKeys="activeRowKeys" :checkBoxClassName="checkBoxClassName" :groupInfo="groupInfo" :cornerMark="cornerMark" @rowClick="handleRowClick" @handleChecked="handleChecked" @loadGroupData="loadGroupData">
      <template v-for="(_, name) in $slots" #[name]="slotProps" :key="name">
        <slot :name="name" v-bind="slotProps" />
      </template>
    </qf-table-body-group>
  </template>
  <template v-if="summaryOptions.enabled">
    <div v-if="virtual.enabled" style="pointer-events: none" :style="{ paddingTop: `${Math.max(allHeight, qfTableBodyHeight - 30)}px` }" />
    <slot name="bodySummary">
      <qf-body-summary :columns="columns" />
    </slot>
  </template>
  <div class="drag-mask" ref="dragMaskRef" />
  <div class="drag-line" ref="dragLineRef" />
</template>

<script setup>
import { ref, reactive, inject, nextTick, onBeforeUnmount } from 'vue';
import QfTableRow from '../qf-table-row/qf-table-row.vue';
import QfBodySummary from '../qf-body-summary/qf-body-summary.vue';
import QfTableBodyGroup from '../qf-table-body-group/qf-table-body-group.vue';

const props = defineProps({
  columns: {
    type: Array,
    default: () => []
  },
  data: {
    type: Array,
    default: () => []
  },
  rowKey: {
    type: String,
    default: 'id'
  },
  expandIcon: {
    type: [Boolean, String],
    default: false
  },
  expandType: {
    type: String,
    default: 'multiple'
  },
  expandedRowKeys: {
    type: Array,
    default: () => []
  },
  checkedParams: {
    type: Object,
    default: () => ({
      enabled: true,
      type: 'checkbox',
      width: 40,
      checked: []
    })
  },
  activeRowKeys: {
    type: Array,
    default: () => []
  },
  errorRowList: {
    type: Array,
    default: () => []
  },
  checkBoxClassName: {
    type: String,
    default: ''
  },
  groupInfo: {
    type: Array,
    default: () => []
  },
  cornerMark: {
    type: Boolean,
    default: false
  },
  totalHeight: {
    type: Number,
    default: 0
  },
  virtual: {
    type: Object
  }
});
// 定义事件
const emits = defineEmits(['rowClick', 'update:expandedRowKeys', 'handleChecked', 'handleExpandChange', 'expandChange', 'loadGroupData', 'rowDragend']);
const tableBody = inject('qfTable')?.qfTableBodyRef;
const tableRef = inject('qfTable')?.qfTableRef;
const rowDragParams = inject('qfTable')?.rowDragParams;
const headerBodyRef = inject('qfTable')?.qfTableHeaderBodyRef;
const headerStickyRef = inject('qfTable')?.qfTableHeaderStickyRef;
const summaryOptions = inject('qfTable')?.summaryOptions;
const qfTableBodyHeight = inject('qfTable')?.bodyHeight;
const dragMaskRef = ref(null);
const dragLineRef = ref(null);
const dragingRow = ref(null);
const targetRow = ref(null);
const targetPosition = ref(null);
const qfTableBodyGroupRef = ref(null);
// 使用对象存储所有行组件的 ref
const tableRowRefs = reactive({});
// 使用两个映射表来存储引用
const rowRefsByIndex = ref([]); // 按索引存储
// 获取行组件 ref 的函数
const setRefs = (row) => {
  return (el) => {
    tableRowRefs[`tableRow_${row[props.rowKey]}`] = el;
  };
};
// 行点击事件
const handleRowClick = ({ e, row }) => {
  emits('rowClick', { e, row });
};
//鼠标悬浮行
// const rowMouseover = (params) => {
//   emits('rowMouseover', params);
// };
// 鼠标移出行
// const rowMouseLeave = (params) => {
//   emits('rowMouseLeave', params);
// };
// 单选事件
const handleChecked = (checked, id) => {
  emits('handleChecked', checked, id);
};
// 刷新单行数据
const refreshRow = (rowKey) => {
  const rowRef = tableRowRefs[rowKey];
  if (rowRef) {
    rowRef.refreshRow();
  }
};

const erp = ref(props.expandedRowKeys || []);
// 展开收缩功能
const handleExpandRow = (e, row) => {
  const id = row?.[props.rowKey];
  console.log(1560, e, id, erp.value);
  if (props.expandType === 'single') {
    if (erp.value.includes(id)) {
      erp.value = [];
    } else {
      erp.value = [id];
    }
  } else if (props.expandType === 'multiple') {
    if (erp.value.includes(id)) {
      erp.value = erp.value?.filter((item) => item != id);
    } else {
      erp.value.push(id);
    }
  } else {
    erp.value = [];
  }
  emits('update:expandedRowKeys', erp.value);
  emits('expandChange', { e, expandRowKeys: erp.value, row });

  // 子表展开/折叠后重新计算行高
  nextTick(() => {
    const index = props.data.findIndex((item) => item[props.rowKey] === id);
    if (index !== -1) {
      const el = rowRefsByIndex.value[index];
      if (el?.offsetHeight) {
        measureRowHeight(index, el.offsetHeight);
        // 触发滚动重新计算
        headerBodyRef.value?.dispatchEvent(new Event('scroll'));
      }
    }
  });
};
// 提供修改行数据的z-index方法
const updateZIndex = ({ rowKey, zIndex }) => {
  if (props.groupInfo?.length) {
    qfTableBodyGroupRef.value.updateZIndex({ rowKey, zIndex });
  } else if (props.virtual.enabled) {
    const rowInfo = findRowByKey(rowKey);
    if (rowInfo?.element) {
      rowInfo.element.style.zIndex = zIndex;
    }
  } else {
    const rowRef = tableRowRefs[`tableRow_${rowKey}`];
    if (rowRef) rowRef.updateZIndex(zIndex);
  }
};
// 分组默认加载数据事件，当最后一层级的分组出现在视口内时，会触发该事件，一般用于调用数据接口
const loadGroupData = (params) => {
  emits('loadGroupData', params);
};

// 设置拖动行阴影的样式
const setDragMaskStyle = (style) => {
  if (!dragMaskRef.value) return;
  for (const key in style) {
    dragMaskRef.value.style.setProperty(key, style[key]);
  }
};

// 设置落点行阴影的样式
const setDragLineStyle = (style) => {
  if (!dragLineRef.value) return;
  for (const key in style) {
    dragLineRef.value.style.setProperty(key, style[key]);
  }
};

let bodyTop = 0;
let bodyHeight = 0;
let bodyScrollHeight = 0;
let dragItemHeight = 0;
let headerBodyTop = 0;
let headerBodyHeight = 0;
let headerBodyScrollTop = 0;
let headerHeight = 0;
let scrolling = false;
let allRowEl = [];

/**
 * @description 开始滑动
 * @param {'down' | 'up'} direction 滑动方向
 */
const startScroll = (direction) => {
  headerBodyScrollTop = Math.max(0, Math.min(headerBodyScrollTop + (direction === 'down' ? 10 : -10), bodyScrollHeight + headerHeight - headerBodyHeight + 10));
  headerBodyRef.value.scrollTop = headerBodyScrollTop;

  const bodyRect = tableBody.value?.getBoundingClientRect();
  bodyTop = bodyRect.top;

  if (scrolling) {
    requestAnimationFrame(() => startScroll(direction));
  }
};

/**
 * @description 拖动行事件移动
 * @param {MouseEvent} e
 */
const dragMousemove = (e) => {
  // 阴影限制在tableBody范围内
  const min = dragItemHeight / 2 + headerBodyScrollTop;
  const max = bodyHeight - dragItemHeight / 2 + headerBodyScrollTop;
  setDragMaskStyle({
    '--top': Math.min(Math.max(e.clientY - bodyTop, min), max) + 'px'
  });

  // 鼠标移动到最后一条数据下面 将落点放到最后一行数据下方
  if (e.target === tableBody.value) {
    targetRow.value = props.data[props.data.length - 1];
    targetPosition.value = 'bottom';
    setDragLineStyle({
      '--top': allRowEl[allRowEl.length - 1]?.getBoundingClientRect().bottom - bodyTop + 'px',
      display: 'block'
    });
  }
  // 鼠标移动到表头 将落点放到第一行数据上方
  if (headerStickyRef.value?.contains(e.target)) {
    targetRow.value = props.data[0];
    targetPosition.value = 'top';
    setDragLineStyle({
      '--top': allRowEl[0]?.getBoundingClientRect().top - bodyTop + 'px',
      display: 'block'
    });
  }

  if (e.clientY - headerBodyTop - headerHeight <= 30 && e.clientY - headerBodyTop - headerHeight >= -30) {
    if (!scrolling) {
      scrolling = true;
      startScroll('up');
    }
  } else if (headerBodyTop + headerBodyHeight - e.clientY <= 30 && headerBodyTop + headerBodyHeight - e.clientY >= -30) {
    if (!scrolling) {
      scrolling = true;
      startScroll('down');
    }
  } else {
    scrolling = false;
  }
};

/**
 * @description 拖动行事件结束
 * @param {MouseEvent} e
 */
const dragMouseup = (e) => {
  scrolling = false;
  setDragMaskStyle({
    display: 'none'
  });
  setDragLineStyle({
    display: 'none'
  });
  const source = dragingRow.value;
  const target = targetRow.value;
  window.removeEventListener('mousemove', dragMousemove);
  dragingRow.value = null;
  targetRow.value = null;
  // 鼠标抬起时判断 1.是否有目标元素 2.鼠标是否在table范围内抬起
  if (!target || !tableRef.value.contains(e.target)) return;
  const sourceIndex = props.data.indexOf(source);
  let targetIndex = props.data.indexOf(target);
  if (targetPosition.value === 'bottom') {
    targetIndex++;
  }
  // 拖动后校验
  const beforeEnd = rowDragParams.value.beforeEnd;
  const emitDrag = () => {
    emits('rowDragend', { e, sourceRow: source, sourceIndex, targetIndex });
  };
  // 如果不是函数 直接返回
  if (typeof beforeEnd !== 'function') return emitDrag();
  const result = beforeEnd({ e, sourceRow: source, sourceIndex, targetIndex });
  // 如果返回值是Promise 则等待Promise resolve后再触发事件
  if (typeof result?.then === 'function') {
    return result.then(emitDrag);
  }
  // 如果返回值是true 则触发事件
  if (result === true) return emitDrag();
};

/**
 * @description 拖动行事件开始
 * @param {MouseEvent} e
 * @param {Object} row 行数据
 */
const onDragstart = (e, row) => {
  if (e.button !== 0) return;
  dragingRow.value = row;
  const bodyRect = tableBody.value?.getBoundingClientRect();
  bodyTop = bodyRect.top;
  bodyHeight = bodyRect.height;
  bodyScrollHeight = tableBody.value.scrollHeight;
  dragItemHeight = e.currentTarget?.getBoundingClientRect().height;
  const headerBodyRect = headerBodyRef.value?.getBoundingClientRect();
  headerBodyTop = headerBodyRect.top;
  headerBodyHeight = headerBodyRect.height;
  headerBodyScrollTop = headerBodyRef.value.scrollTop;
  headerHeight = headerStickyRef.value?.getBoundingClientRect().height || 0;
  setDragMaskStyle({
    '--height': dragItemHeight + 'px',
    '--top': e.clientY - bodyTop + 'px',
    display: 'block'
  });
  allRowEl = [...tableBody.value.children]?.filter((item) => item.classList?.contains('qf-table-row'));
  // 鼠标离开table区域隐藏引导线
  const levelTable = () => setDragLineStyle({ display: 'none' });
  const enterTable = () => setDragLineStyle({ display: 'block' });
  tableRef.value.addEventListener('mouseleave', levelTable);
  tableRef.value.addEventListener('mouseenter', enterTable);
  // 鼠标抬起做拖拽
  window.addEventListener(
    'mouseup',
    (e) => {
      dragMouseup(e);
      tableRef.value.removeEventListener('mouseleave', levelTable);
      tableRef.value.removeEventListener('mouseenter', enterTable);
    },
    { once: true }
  );
  window.addEventListener('mousemove', dragMousemove);
};

/**
 * @description 拖动行事件鼠标悬浮
 * @param {MouseEvent} e
 * @param {Object} row 行数据
 */
const onDragmouseover = (e, row) => {
  if (!dragingRow.value) return;
  targetRow.value = row;
  // 计算落点 鼠标在目标元素中间位置以上 则目标位置为top 以下则为bottom
  const targetRect = e.currentTarget?.getBoundingClientRect();
  const mousePosition = e.clientY - targetRect.top;
  const middle = targetRect.height / 2;
  targetPosition.value = mousePosition > middle ? 'bottom' : 'top';
  let lineTop = targetRect.top - bodyTop;
  if (targetPosition.value === 'bottom') {
    lineTop = targetRect.bottom - bodyTop;
  }
  setDragLineStyle({
    '--top': lineTop + 'px',
    display: 'block'
  });
};

defineExpose({
  refreshRow,
  updateZIndex
});
/***********************虚拟滚动相关**************************** */
const virtualList = inject('virtualList');

const {
  visibleRows = ref([]), // 默认值
  getRowStyle,
  setRowRef,
  measureRowHeight,
  findRowByKey,
  allHeight
} = virtualList || {};

/***********************虚拟滚动相关**************************** */

// 组件卸载时清理资源
onBeforeUnmount(() => {
  // 清理引用对象
  for (const key in tableRowRefs) {
    delete tableRowRefs[key];
  }

  // 清理数组引用
  rowRefsByIndex.value = [];

  // 清理拖动相关资源
  scrolling = false;
  dragingRow.value = null;
  targetRow.value = null;

  // 移除全局事件监听器
  window.removeEventListener('mousemove', dragMousemove);
  window.removeEventListener('mouseup', dragMouseup);

  // 清理DOM引用
  dragMaskRef.value = null;
  dragLineRef.value = null;
  qfTableBodyGroupRef.value = null;
});
</script>

<style scoped lang="less">
@import './qf-table-body.less';
</style>
